import React, { useEffect, useState } from "react"
import { graphql, PageProps } from "gatsby"

import { Layout } from "@interia/common/components/layout"
import Seo from "../components/seo/seo"
import {
  DownloadableAssets,
  PaginationPosts,
  Posts,
  Specialist,
} from "../components/sections"
import useMainMenu from "../hooks/useMainMenu"
import styled from "styled-components"
import { Section } from "@interia/common/components/section"
import { H2 } from "@interia/common/components/typography"
import { palette } from "@interia/common/styles/global"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import { Post } from "types"
import {
  HeaderWrapper,
  Background,
  Title,
  Description,
  Wrapper,
  TextImage,
  NavWrapper,
  LinkWrapper,
  NavLink,
  NavLinkArrow,
  AboveTextImage,
  AboveTextImageWrapper,
} from "./post-template.style"
import { ButtonArrow } from "@interia/common/components/shapes"
import usePostsPageData from "../../src/hooks/usePostsPageData"
import usePosts from "../hooks/usePosts"
const HtmlToReactParser = require("html-to-react").Parser
import useFooter from "../hooks/useFooter"
import useHeader from "../hooks/useHeader"

type Props = {
  pageContext: {
    prevPost: Post | null
    post: Post
    nextPost: Post | null
  }
}

const PostTemplate = ({ pageContext }: Props) => {
  const posts = usePosts("aktualnosci")
  const [prevPost, setPrevPost] = useState<Post | null>(null)
  const [nextPost, setNextPost] = useState<Post | null>(null)
  const { post } = pageContext
  const menuItems = useMainMenu()
  const gatsbyImage = getImage(post.featuredImage?.node.gatsbyImage)
  const textGatsbyImage = getImage(
    post.postOptions.textimage?.gatsbyImage ?? null
  )
  const aboveTextGatsbyImage = getImage(
    post.postOptions.abovetextimage?.gatsbyImage ?? null
  )
  const htmlToReactParser = new HtmlToReactParser()
  const parsedDescription = htmlToReactParser.parse(
    post.postOptions.description
  )
  const parsedLongDescription = htmlToReactParser.parse(
    post.postOptions.longdescription
  )
  const footer = useFooter()
  const header = useHeader()

  useEffect(() => {
    const findedPostIndex = posts.findIndex(({ slug }) => {
      return slug == post.slug
    })
    if (findedPostIndex != -1) {
      if (findedPostIndex > 0) {
        const prevPostTemp = posts[findedPostIndex - 1]
        setPrevPost(prevPostTemp)
      }
      if (findedPostIndex < posts.length - 1) {
        const nextPostTemp = posts[findedPostIndex + 1]
        setNextPost(nextPostTemp)
      }
    }
  }, [posts])

  return (
    <Layout
      footer={footer}
      gemiusId="0nKacee.fzah6lJ8915YdYZR7FlRDyyXVPlG5jJtFhH.P7"
      logoUrl={{ external: false, url: "/", image: header?.headeroptions.logo }}
      menuItems={menuItems}
      actualSite="aktualnosci"
    >
      <Seo title={post.postOptions.title} openGraph={post.openGraphOptions} />
      {aboveTextGatsbyImage && post.postOptions.abovetextimage && (
        <AboveTextImageWrapper>
          <AboveTextImage
            image={aboveTextGatsbyImage}
            alt={post.postOptions.abovetextimage.altText}
          />
        </AboveTextImageWrapper>
      )}
      <HeaderWrapper>
        <article>
          <Description>Informacje Prasowe</Description>
          <Title>{post.postOptions.title}</Title>
          <Description>{parsedDescription}</Description>
        </article>
        <div>
          {gatsbyImage && (
            <GatsbyImage
              image={gatsbyImage}
              alt={post.featuredImage?.node.altText}
            />
          )}
        </div>
      </HeaderWrapper>
      <Wrapper>
        {textGatsbyImage && post.postOptions.textimage && (
          <TextImage
            image={textGatsbyImage}
            alt={post.postOptions.textimage.altText}
          />
        )}
        <Description>{parsedLongDescription}</Description>
      </Wrapper>
      <div style={{ display: "inline-block", width: "100%" }}>
        <NavWrapper>
          <LinkWrapper>
            {prevPost && (
              <NavLink to={`/aktualnosci/${prevPost.slug}`}>
                <NavLinkArrow
                  style={{
                    transform: "rotate(-45deg)",
                    marginRight: "0.5rem",
                    marginBottom: "0.15rem",
                  }}
                />
                Poprzednia
              </NavLink>
            )}
          </LinkWrapper>
          <LinkWrapper>
            {nextPost && (
              <NavLink to={`/aktualnosci/${nextPost.slug}`}>
                Następna{" "}
                <NavLinkArrow
                  style={{ transform: "rotate(135deg)", marginLeft: "0.5rem" }}
                />
              </NavLink>
            )}
          </LinkWrapper>
        </NavWrapper>
      </div>
    </Layout>
  )
}

export default PostTemplate
